import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { signInSuccess } from '../store/authentication.action';
import { environment } from '../../../environments/environment';
import { JWTService } from '../service/jwt.service';

@Component({
  selector: 'sibat-azure-callback',
  template: '',
})
export class AzureCallbackComponent implements OnInit {
  constructor(private store: Store, private http: HttpClient, private router: Router, private jwtService: JWTService) {}

  ngOnInit(): void {
    this.http
      .get<{ token: string; role: string }>(`${environment.apiUrl}/auth/bridge`, {
        withCredentials: true,
      })
      .subscribe({
        next: ({ token, role }) => {
          this.store.dispatch(signInSuccess({ token: `Bearer ${token}` }));
        },
        error: () => {
          this.jwtService.clearToken();
          this.router.navigate(['/signin']);
        },
      });
  }
}
